// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


let Percentage = {};

function toString(v) {
  return v;
}

function ofString(v) {
  return v;
}

let Space = {
  none: "0px",
  xs: "4px",
  s: "8px",
  m: "16px",
  l: "32px",
  xl: "64px",
  xxl: "128px",
  toString: toString,
  ofString: ofString
};

function toString$1(v) {
  return v;
}

function ofString$1(v) {
  return v;
}

let Breakpoint = {
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
  toString: toString$1,
  ofString: ofString$1
};

exports.Percentage = Percentage;
exports.Space = Space;
exports.Breakpoint = Breakpoint;
/* No side effect */
